import { render, staticRenderFns } from "./AgentDetailPair.vue?vue&type=template&id=58c33a47&"
import script from "./AgentDetailPair.vue?vue&type=script&lang=js&"
export * from "./AgentDetailPair.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports